const prefix = "ASSIGNMENT_DETAILS";
const defaultGuid = "00000000-0000-0000-0000-000000000000";
export {
  defaultGuid,
  prefix
};
//# sourceMappingURL=constants.js.map
